import { render, staticRenderFns } from "./ProviderUsers.vue?vue&type=template&id=88d4e8e0&"
import script from "./ProviderUsers.vue?vue&type=script&lang=js&"
export * from "./ProviderUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports